<template>
    <c-modal v-model="props.isOpen" :title="props.title" @ok="props.handleClose">
        <template #modal-title>
            <font-awesome-icon :icon="['fas', 'triangle-exclamation']" style="color: #ffd43b" />
            <b>There was a problem</b>
        </template>
        <div class="row justify-content-between ml-2">
            <div ref="errorMessage" class="col">
                <div>{{ modalErrorDescription }}</div>

                <div>Please, contact our support team so they can help you out.</div>
            </div>
            <div class="col-2">
                <button class="btn copy-btn float-right" @click="copyErrorMessage">
                    <font-awesome-icon :icon="['fas', 'copy']" size="lg" style="color: #000000" />
                </button>
            </div>
        </div>
    </c-modal>
</template>
<script setup lang="ts">
import CModal from './CModal.vue';

const props = defineProps<{
    isOpen: boolean;
    title: string;
    modalErrorDescription: string;
    errorMessage: string;
    handleClose: () => void;
}>();

const emits = defineEmits<{
    (event: 'error-message-copied'): void;
    (event: 'failed-to-copy-error', value: string): void;
}>();

const copyErrorMessage = async () => {
    try {
        const msgToCopy = props.errorMessage.replaceAll('\n\n\n', '\n\n');
        if (!msgToCopy) {
            return;
        }
        await navigator.clipboard.writeText(msgToCopy);
        emits('error-message-copied');
    } catch (error) {
        emits('failed-to-copy-error', (error as Error).message);
    }
};
</script>
